import {Component} from "@angular/core";
import {FamilyAlbum} from "../../../model/family-album";
import {BusinessService} from "../../../services/data/business.service";
import {Router} from "@angular/router";
import {CurrentEventService} from "../../../services/communication/currentEventService";
import {DateFormatter} from "../../../model/date-formatter";

@Component({
  selector: 'event-edition',
  template: require('./event-edition.component.html'),
  styles: [
    require('./event-edition.component.scss')
  ]
})

export class EventEditionComponent {
  model = new FamilyAlbum();
  currentEvent: FamilyAlbum;
  submitted = false;

  inputDate: string;

  date:number;
  isPublic:boolean = false;
  isDateValid:boolean = true;

  myDatePickerOptions = {
    todayBtnTxt: 'Aujourd\'hui',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    inline: false,
    locale: 'fr',
    dateFormat: 'dd/mm/yyyy',
    selectionTxtFontSize: '16px'
  };

  constructor(private businessService:BusinessService,
              private router:Router,
              private currentEventService: CurrentEventService) {
    this.model = JSON.parse(JSON.stringify(currentEventService.currentEvent));
    this.currentEvent = currentEventService.currentEvent;
    this.inputDate = DateFormatter.format(this.model.date);
    this.date = this.model.date;
  }

  onDateChanged(event:any) {
    if (event.formatted != undefined && event.formatted != "") {
      this.isDateValid = true;
      this.date = event.epoc*1000;
    } else {
      this.isDateValid = false;
    }
  }

  back():void {
    this.router.navigateByUrl('/event/'+this.model.id);
  }

  updateEvent() {
    this.model.date = this.date;

    this.businessService.updateEvent(this.model).subscribe(
      event => {
        this.currentEventService.currentEvent = event;
        this.back();
      }
    );
  }

  delete() {
    this.businessService.deleteEvent(this.model.id).subscribe(
        response => this.router.navigateByUrl('/home/events')
    );
  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/event/event-edition/event-edition.component.ts